import dayjs, { Dayjs } from 'dayjs'
import { TFunction } from 'i18next'

export const getTicketStatusColor = (status: string) => {
    switch (status) {
        case 'opening':
            return 'info'
        case 'work-in-progress':
            return 'primary'
        case 'completed':
            return 'warning'
        case 'closed':
            return 'success'
        case 'pending':
            return 'warning'
        case 'cancelled':
            return 'error'
        case 'escalated':
            return 'error'
        default:
            return 'default'
    }
}
export const getTicketUrgencyColor = (status: string) => {
    switch (status) {
        case 'medium':
            return 'primary'
        case 'low':
            return 'warning'
        case 'high':
            return 'error'
        case 'Chưa phân loại':
            return 'error'
        default:
            return 'default'
    }
}

export const TicketStatus = (t: TFunction<'translation', undefined>) => [
    {
        label: t('ticket-opening'),
        value: 'opening',
    },
    {
        label: t('ticket-work-in-progress'),
        value: 'work-in-progress',
    },
    {
        label: t('ticket-completed'),
        value: 'completed',
    },
    {
        label: t('ticket-closed'),
        value: 'closed',
    },
    {
        label: t('ticket-cancelled'),
        value: 'cancelled',
    },
    {
        label: 'Escalated',
        value: 'escalated',
    },
]

export const TicketUrgency = (t: TFunction<'translation', undefined>) => [
    {
        label: t('ticket-low'),
        value: 'low',
    },
    {
        label: t('ticket-medium'),
        value: 'medium',
    },
    {
        label: t('ticket-high'),
        value: 'high',
    },
]

export const TICKET_SOURCE = () => [
    {
        label: 'HOTLINE',
        value: 'HOTLINE',
    },
    {
        label: 'EMAIL',
        value: 'EMAIL',
    },
    {
        label: 'ZALO',
        value: 'ZALO',
    },
    {
        label: 'OTHERS',
        value: 'OTHERS',
    },
    {
        label: 'TECH SUPPORT',
        value: 'TECH SUPPORT',
    },
    {
        label: 'SKYPE',
        value: 'SKYPE',
    },
    {
        label: 'TELEGRAM',
        value: 'TELEGRAM',
    },
    {
        label: 'AUTOMATION',
        value: 'AUTOMATION',
    },
    {
        label: 'DATACENTRAL/SERVICE',
        value: 'datacentral/service',
    },
]
export const TicketResponseLate = (t: TFunction<'translation', undefined>) => [
    {
        label: t('ticket-late'),
        value: 'late',
    },
    {
        label: t('ticket-unlate'),
        value: 'unlate',
    },
]
export const TicketMarjorable = () => [
    {
        label: 'Major Incident',
        value: true,
    },
    {
        label: 'Non Major Incident',
        value: false,
    },
]

export const TicketTypeGroupOptions = (
    t: TFunction<'translation', undefined>
) => [
    {
        label: t('ticket-type-group-error-service'),
        value: 'error_service',
    },
    {
        label: t('ticket-type-group-service-request'),
        value: 'service_request',
    },
    {
        label: t('ticket-type-group-support-request'),
        value: 'support_request',
    },
    {
        label: t('ticket-type-group-service'),
        value: 'service',
    },
    {
        label: t('ticket-type-group-meeting'),
        value: 'meeting',
    },
    {
        label: t('ticket-type-group-change'),
        value: 'change',
    },
    {
        label: t('ticket-type-group-internal'),
        value: 'internal',
    },
]

export const MeetingPurpose = (t: TFunction<'translation', undefined>) => [
    {
        label: t('meeting-purpose-presale'),
        value: 'presale_presentation',
    },
    {
        label: t('meeting-purpose-support'),
        value: 'support',
    },
    {
        label: t('meeting-purpose-relationship'),
        value: 'relationship',
    },
    {
        label: t('meeting-purpose-negotiation'),
        value: 'negotiation',
    },
]

export const MeetingType = (t: TFunction<'translation', undefined>) => [
    {
        label: t('meeting-type-online'),
        value: 'online',
    },
    {
        label: t('meeting-type-offline'),
        value: 'offline',
    },
]

export const MeetingChannel = () => [
    {
        label: 'Zoom',
        value: 'zoom',
    },
    {
        label: 'Google Meet',
        value: 'google-meet',
    },
    {
        label: 'Microsoft Teams',
        value: 'microsoft-teams',
    },
    {
        label: 'Other',
        value: 'other',
    },
]
export const formatDate = (
    date?: string | Date | Dayjs | null
): string | null => {
    if (!date) return null

    const d = dayjs.isDayjs(date) ? date : dayjs(date)
    return d.isValid() ? d.format('YYYY-MM-DD') : null
}
// IT-ISMS: Security classification tag options per QT-01 §4.2
export const TicketSecurityTagOptions = () => [
    { label: 'None', value: 'none' },
    { label: 'Security', value: 'security' },
    { label: 'Service', value: 'service' },
    { label: 'Both', value: 'both' },
]

// IT-ISMS: Security tag color mapping
export const getSecurityTagColor = (tag: string) => {
    switch (tag) {
        case 'security':
            return 'error'
        case 'service':
            return 'primary'
        case 'both':
            return 'warning'
        case 'none':
        default:
            return 'default'
    }
}

// IT-ISMS: P1-P4 priority label with color
export const getISMSPriorityColor = (priority: string) => {
    switch (priority) {
        case 'P1':
            return 'error'
        case 'P2':
            return 'error'
        case 'P3':
            return 'primary'
        case 'P4':
            return 'warning'
        default:
            return 'default'
    }
}

export const TICKET_ATTACHMENT_FILE_PREFIX = 'tickets'

export const canTicketBeRated = (
    ticketStatus: string,
    completedDate?: string | Date | null,
    timeoutDays: number = 7
): boolean => {
    if (ticketStatus !== 'closed') {
        return false
    }

    if (!completedDate) {
        return true
    }

    const completedDateObj = dayjs(completedDate)
    const now = dayjs()
    const daysDiff = now.diff(completedDateObj, 'day')

    return daysDiff <= timeoutDays
}

export const isRatingTimeoutExpired = (
    completedDate?: string | Date | null,
    timeoutDays: number = 7
): boolean => {
    if (!completedDate) {
        return false
    }

    const completedDateObj = dayjs(completedDate)
    const now = dayjs()
    const daysDiff = now.diff(completedDateObj, 'day')

    return daysDiff > timeoutDays
}
